import { TaxesAllIncludedContent } from '@/app/components/search/components/Tooltip/Tooltips/TaxesModal';
import { formatPrice } from '@/app/components/search/utils/formatting.ts';
import { usePageWrapperData } from '@/app/common/pageWrapperProvider.tsx';
import { useTranslation } from '@/app/components/translations/Translation';
import usePriceDisplay from '@/app/components/hotel-detail/hooks/usePriceDisplay.ts';
import { useUrlSearchParams } from '../UrlSearchParamsProvider';
import useUserConfig from '../hooks/useUserConfig';
import { getDoublePricingAmounts } from './roomCommon';

// Shared breakdown panel for the "all taxes included" tooltip on hotel detail.
// Family searches render group totals; adults-only render per-person with a `pp` suffix.
export function TaxesAllIncludedBreakdown({
  pricePerPerson,
  taxesPerPerson,
}: {
  pricePerPerson: number;
  taxesPerPerson: number;
}) {
  const { t } = useTranslation();
  const { localization } = usePageWrapperData();
  const { totalGuestsWithoutInfants } = useUrlSearchParams();
  const { isDoublePriceDP } = useUserConfig();
  const { showTotalPrice } = usePriceDisplay();

  const dpAmounts = getDoublePricingAmounts({
    pricePerPerson,
    taxesPerPerson,
    passengers: totalGuestsWithoutInfants,
    isDoublePriceDP,
    showTotalPrice,
  });

  return (
    <TaxesAllIncludedContent
      priceLabel={t('vacation.common.flightplushotel')}
      priceWithoutTaxes={formatPrice({ price: dpAmounts.basePrice, localization })}
      taxesLabel={`${t('vacation.common.citytaxes.taxes')} ${t('vacation.common.citytaxes.payablehotel')}`}
      taxesPrice={formatPrice({ price: dpAmounts.taxes, localization })}
      totalLabel={t('vacation.common.price.total')}
      totalPrice={formatPrice({ price: dpAmounts.total, localization })}
      explanation={t('vacation.oss.cards.taxes_fees_included.all.desc')}
      ppSuffix={dpAmounts.showPpSuffix ? t('vacation.oss.cards.pp') : undefined}
    />
  );
}
